import React from 'react';
import {Grid} from "@mui/material";
import Employee from "../../Employee/Employee";


function OurTeam() {
    return <>
        <Grid container style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
            <Grid item xs={12} md={6} lg={3} className={'grid--item-top'}>
                <Employee name={'Rainer Seubert'} empl={'img--rainer'} task={'CEO | Shareholder'}
                          degree={"Economist (VWA)"} maildummy={'rainer.seubert[at]bioretis.com'}/>
            </Grid>
        </Grid>
        <Grid container
              style={{display: "flex", justifyContent: "space-evenly", alignItems: "center"}}>

            <Grid item xs={12} md={6} lg={3} className={'grid--item-top'}>
                <Employee name={'Till Sörensen'} degree={'DIPL. MATHEMATICS'} empl={'img--till'}
                          task={'Shareholder | Head of Analystics '} maildummy={'till.soerensen[at]bioretis.com'}/>
            </Grid>
            <Grid item xs={12} md={6} lg={3} className={'grid--item-top'}>
                <Employee name={'Sascha Johannes'} degree={'M. SC. BIOINFORMATICS'} empl={'img--sascha'}
                          task={'Shareholder | Head of Development'} maildummy={'sascha.johannes[at]bioretis.com'}/>
            </Grid>
            <Grid item xs={12} md={6} lg={3} className={'grid--item-top'}>
                <Employee name={'Bettina Johannes'} degree={'B. SC. MATHEMATICS'} empl={'img--bettina'}
                          task={'Research & Development'} maildummy={'bettina.johannes[at]bioretis.com'}/>
            </Grid>
        </Grid>
        <Grid container style={{
            display: "flex",
            justifyContent: "space-evenly",
            alignItems: "center",
        }}>
            <Grid item xs={12} md={6} lg={3} className={'grid--item-top'}>
                <Employee name={'Thomas Häupl'} degree={'PD DR. MED. HABIL.'} empl={'img--thomas'}
                          task={'Main Shareholder | Founder'} maildummy={'thomas.haeupl[at]bioretis.com'}/>
            </Grid>
            <Grid item xs={12} md={6} lg={3} className={'grid--item-top'}>
                <Employee name={'Marc Bonin-Andresen'} degree={'M. SC. BIOINFORMATICS'} empl={'img--marc'}
                          task={'Shareholder'} maildummy={'marc.bonin-andresen[at]bioretis.com'}/>
            </Grid>
        </Grid>
    </>
}

export default OurTeam;